import type {
	TypographyStyleOptions,
} from '@mui/material/styles/createTypography'

export const materialUITypographyTheme: {
	typography: TypographyStyleOptions
} = {
	typography: {
		color:      'var(--on-surface-color)',
		fontFamily: 'var(--font-family-base)',
		fontSize:   'var(--font-size-body-medium)',

		'heading-large': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-heading-large)',
			fontWeight: 'var(--font-weight-semibold)',
		},
		'heading-medium': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-heading-medium)',
			fontWeight: 'var(--font-weight-semibold)',
		},
		'heading-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-heading-small)',
			fontWeight: 'var(--font-weight-semibold)',
		},

		'title-large': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-title-large)',
			fontWeight: 'var(--font-weight-semibold)',
		},
		'title-medium': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-title-medium)',
			fontWeight: 'var(--font-weight-medium)',
		},
		'title-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-title-small)',
			fontWeight: 'var(--font-weight-medium)',
		},

		'body-large': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-large)',
			fontWeight: 'var(--font-weight-semibold)',
		},
		'body-medium': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-medium)',
			fontWeight: 'var(--font-weight-medium)',
		},
		'body-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-small)',
			fontWeight: 'var(--font-weight-regular)',
		},
		'body-x-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-x-small)',
			fontWeight: 'var(--font-weight-medium)',
		},
		'body-xs-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-xs-small)',
			fontWeight: 'var(--font-weight-medium)',
		},
		'body-xxl-small': {
			color:      'var(--on-surface-color)',
			fontSize:   'var(--font-size-body-xxl-small)',
			fontWeight: 'var(--font-weight-regular)',
		},
		'body-link-small': {
			color:      'var(--primary-color)',
			fontSize:   'var(--font-size-body-small)',
			fontWeight: 'var(--font-weight-medium)',
			position:   'relative',
			transition: 'color, 0.2s ease-in-out',

			'&::after': {
				content:      '""',
				position:     'absolute',
				bottom:       '-2px',
				left:         0,
				opacity:      0.5,
				width:        '100%',
				height:       '2px',
				borderRadius: 'var(--border-radius-m)',
				transition:   'color, opacity, 0.1s ease-in-out',
				transform:    'scaleX(0)',
				background:   'var(--primary-color)',
			},

			'&:hover': {
				color: 'var(--primary-color)',

				'&::after': {
					opacity:    1,
					transform: 'scaleX(1)',
				},
			},
		},
	},
}
